import React from 'react';

import PropTypes from 'prop-types';

import './BusinessUnitSelection.scss';

export const BusinessUnitSelection = ({ options, onOptionSelected }) => (
  <div className="businessUnitSelection">
    {(options || []).map(
      (option) =>
        option.imageName && (
          <button
            className="imageItem"
            key={option.key}
            onClick={() => onOptionSelected(option.key)}>
            <img
              alt={option?.alt || ''}
              // eslint-disable-next-line import/no-dynamic-require, global-require
              src={require(`assets/pics/${option?.imageName}`)}
            />
          </button>
        )
    )}
  </div>
);

BusinessUnitSelection.propTypes = {
  options: PropTypes.array.isRequired,
  onOptionSelected: PropTypes.func.isRequired,
};
